import { render } from "./RecommendCover.vue?vue&type=template&id=6be2402f&scoped=true&ts=true"
import script from "./RecommendCover.vue?vue&type=script&lang=ts"
export * from "./RecommendCover.vue?vue&type=script&lang=ts"

import "./RecommendCover.vue?vue&type=style&index=0&id=6be2402f&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be2402f"]])

export default __exports__